import React, { useState, useEffect } from 'react';
import { Button, Form, Image, ProgressBar, Badge, Modal, FormText, Accordion, Card, Row, Col, Container } from 'react-bootstrap';
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';


function Welcome() {

  return (
    <>
      <RenderHeader />
      <NavbarSmart />
      <Container>
        <Row>
          <Col>
            <Card style={{border:"0px"}}>
              <Card.Title>
              <br/>
              Welcome
              </Card.Title>
              <Card.Body>
                Welcome to Gem City Jobs.  I created this site to post jobs that I've found for various companies around the Dayton, Cincinnati, and Columbus areas.  
                <br/>&nbsp;<br/>
                We don't share personal info and the service is always free.  I hope this helps you find your next adventure.
                <br/>&nbsp;<br/>
                -- Phil
              {/* <Link to="/login">
                <Button to="/login">Login</Button>
              </Link>
              <Link to="/signup">
                <Button>Sign up</Button>
              </Link> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Welcome;